import { Component, OnInit } from '@angular/core';
import { ApiRequestModelShow } from '../../models/api-request-model-show';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { UserApiService } from '../../services/user-api.service';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/logger.service';

@Component({
  selector: '.app-apidocumentaion.container-xxl.flex-grow-1.p-0',
  templateUrl: './apidocumentaion.component.html',
  styleUrls: ['./apidocumentaion.component.css']
})

export class APIDocumentaionComponent implements OnInit {

  constructor(
    private logger: LoggerService
    , private apiService: UserApiService
    , private modalService: NgbModal
    , private offcanvasService: NgbOffcanvas) {
    this.dataSource = [];
    this.data = [];
  }

  public dataSource: any[];

  public data: any[];

  public selectApiItem!: ApiRequestModelShow;

  public successMessage: boolean = false;

  public searchedItem: string = '';

  public selectedItem?: number;

  public selectedGroupItem?: number;

  public codeAlertBox: boolean = false;

  public loading: boolean = false;

  public thisData?: string;

  public ngOnInit(): void {
    try {
      let url = `assets/json/Api.json`;

      this.apiService.getJson(new ApiRequestModel(url))
        .subscribe(
          result => {
            this.logger.addResponseLog(url, result, `Get All`);
            this.dataSource = result.item;
            this.data = result.item;
            this.selectApi(this.data[3].item[3], 0, 0);
          },
          error => {
            
            this.logger.addException(error,true);
          },
          () => {
          }
        );
    } catch (error) {
      
      this.logger.addException(error,true);
    }
  }

  public selectApi(item: any, indexParent: number, indexChild: number) {
    try {
      this.loading = true;
      this.selectApiItem = new ApiRequestModelShow();
      this.selectApiItem.method = item.request.method;
      this.selectApiItem.url = item.request.url.raw;
      if (item.request?.body?.raw != null
        && item.request?.body?.raw != "") {
        this.selectApiItem.requestString = item.request.body.raw;
        this.selectApiItem.request = JSON.parse(item.request.body.raw);
      } else {
        this.selectApiItem.requestString = "";
      }

      var foundedSuccessResponse = item.response
        .filter(current => current.name.toLowerCase() == 'success');

      if (foundedSuccessResponse.length > 0) {
        if (foundedSuccessResponse[0].body != null
          && foundedSuccessResponse[0].body != "") {
          this.selectApiItem.responseSuccessString = foundedSuccessResponse[0].body;
          this.selectApiItem.responseSuccess = JSON.parse(foundedSuccessResponse[0].body);
        } else {
          this.selectApiItem.responseSuccessString = "";
        }
      }

      var foundedErrorResponse = item.response
        .filter(current => current.name.toLowerCase() == 'error');

      if (foundedErrorResponse.length > 0) {
        if (foundedErrorResponse[0].body != null
          && foundedErrorResponse[0].body != "") {
          this.selectApiItem.responseErrorString = foundedErrorResponse[0].body;
          this.selectApiItem.responseError = JSON.parse(foundedErrorResponse[0].body);
        } else {
          this.selectApiItem.responseErrorString = "";
        }
      }

      for (let index = 0; index < item.request.url.path.length; index++) {
        const element = item.request.url.path[index];
        this.selectApiItem.insideRouting += `/`;
        this.selectApiItem.insideRouting += element;
      }

      var bodyString = JSON.stringify(this.selectApiItem.request).replaceAll(",", ", ");
      this.selectedItem = indexParent;
      this.selectedGroupItem = indexChild;
      this.selectApiItem.curl.push(`curl --location --request ${this.selectApiItem.method} '${this.selectApiItem.url}' \ `);
      this.selectApiItem.curl.push(`     --header 'Content-Type: application/json' \ `);
      this.selectApiItem.curl.push(`     --header 'Authorization: Bearer ***' \ `);
      this.selectApiItem.curl.push(`     --data '${bodyString}'`);

      this.selectApiItem.csharp.push(`var options = new RestClientOptions("${this.selectApiItem.url}")`);
      this.selectApiItem.csharp.push(`{`);
      this.selectApiItem.csharp.push(`  MaxTimeout = -1,`);
      this.selectApiItem.csharp.push(`};`);
      this.selectApiItem.csharp.push(`var client = new RestClient(options);`);
      this.selectApiItem.csharp.push(`var request = new RestRequest("${this.selectApiItem.insideRouting}", Method.${this.selectApiItem.method});`);
      this.selectApiItem.csharp.push(`request.AddHeader("Content-Type", "application/json");`);
      this.selectApiItem.csharp.push(`request.AddHeader("Authorization", "Bearer ***");`);
      this.selectApiItem.csharp.push(`var body = "${bodyString}";`);
      this.selectApiItem.csharp.push(`request.AddStringBody(body, DataFormat.Json)`);
      this.selectApiItem.csharp.push(`RestResponse response = await client.ExecuteAsync(request);`);
      this.selectApiItem.csharp.push(`Console.WriteLine(response.Content);`);

      this.selectApiItem.java.push(`Unirest.setTimeouts(0, 0);`);
      this.selectApiItem.java.push(`HttpResponse<String> response = Unirest.get("${this.selectApiItem.url}")`);
      this.selectApiItem.java.push(`  .header("Content-Type", "application/json")`);
      this.selectApiItem.java.push(`  .header("Authorization", "Bearer ****")`);
      this.selectApiItem.java.push(`  .body("${bodyString}")`);
      this.selectApiItem.java.push(`  .asString();`);

      this.selectApiItem.jQuery.push(`var settings = {`);
      this.selectApiItem.jQuery.push(`  "url": "${this.selectApiItem.url}",`);
      this.selectApiItem.jQuery.push(`  "method": "${this.selectApiItem.method}",`);
      this.selectApiItem.jQuery.push(`  "timeout": 0,`);
      this.selectApiItem.jQuery.push(`  "headers": {`);
      this.selectApiItem.jQuery.push(`    "Content-Type": "application/json",`);
      this.selectApiItem.jQuery.push(`    "Authorization": "Bearer ****"`);
      this.selectApiItem.jQuery.push(`  },`);
      this.selectApiItem.jQuery.push(`  "data": JSON.stringify({${this.selectApiItem.requestString}}`);
      this.selectApiItem.jQuery.push(`  }),`);
      this.selectApiItem.jQuery.push(`};`);
      this.selectApiItem.jQuery.push(`$.ajax(settings).done(function (response) {`);
      this.selectApiItem.jQuery.push(`  console.log(response);`);
      this.selectApiItem.jQuery.push(`});`);

      this.selectApiItem.kotlin.push(`val client = OkHttpClient()`);
      this.selectApiItem.kotlin.push(`val request = Request.Builder()`);
      this.selectApiItem.kotlin.push(`  .url("${this.selectApiItem.url}")`);
      this.selectApiItem.kotlin.push(`  .addHeader("Content-Type", "application/json")`);
      this.selectApiItem.kotlin.push(`  .addHeader("Authorization", "Bearer ****")`);
      this.selectApiItem.kotlin.push(`  .build()`);
      this.selectApiItem.kotlin.push(`val response = client.newCall(request).execute()`);

      this.selectApiItem.Python.push(`import requests`);
      this.selectApiItem.Python.push(``);
      this.selectApiItem.Python.push(`url = "${this.selectApiItem.url}"`);
      this.selectApiItem.Python.push(``);
      this.selectApiItem.Python.push(`payload = json.dumps(`);
      this.selectApiItem.Python.push(`${bodyString}`);
      this.selectApiItem.Python.push(`})`);
      this.selectApiItem.Python.push(``);
      this.selectApiItem.Python.push(`headers = {`);
      this.selectApiItem.Python.push(`    'Authorization': 'Bearer ***`);
      this.selectApiItem.Python.push(`}`);
      this.selectApiItem.Python.push(``);
      this.selectApiItem.Python.push(`response = requests.request("${this.selectApiItem.method}", url, `);
      this.selectApiItem.Python.push(`    headers=headers, data=payload)`);
      this.selectApiItem.Python.push(``);
      this.selectApiItem.Python.push(`print(response.text)`);
      this.selectApiItem.Python.push(``);
      
      this.fetchFields();
    } catch (error) {
      
      this.logger.addException(error,true);
    }
  }

  public fetchFields() {
    try {
      if (this.thisData != null
        && this.thisData == this.selectApiItem.insideRouting) {
        return;
      }

      this.apiService.getEntity(new ApiRequestModel(this.selectApiItem.insideRouting))
        .subscribe(
          result => {
            this.logger.addResponseLog(this.selectApiItem.insideRouting, result, `Get Entity`);
           if (result.length==0) {
            this.loading = false;
            return;
           }
            this.selectApiItem.fileds = result[0].fields
              .map(current => ({
                name: current.fieldName,
                type: current.fieldDatatype,
                isMandatory: current.ismAndaTory,
                pattern: current.pattern,
                editable: current.noEditable
              }));
            this.thisData = this.selectApiItem.insideRouting;

            this.loading = false;
          },
          error => {
            
            this.logger.addError(error,true);
          },
          () => {
          }
        );
    } catch (error) {
      
      this.logger.addException(error,true);
    }
  }

  public copyToclipboard(val: string) {
    try {
      const selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = val;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
      this.successMessage = true;
    } catch (error) {
      
      this.logger.addException(error,true);
    }
  }

  public searchApi() {
    try {
      if (this.searchedItem == null || this.searchedItem == '') {
        this.data = this.dataSource;
      } else {
        this.data = [];
        this.data = this.dataSource
          .filter(current => current.name.toLowerCase().indexOf(this.searchedItem.toLowerCase()) >= 0)
      }
    } catch (error) {
      
      this.logger.addException(error,true);
    }
  }

  public openModal(content: any) {
    try {
      this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {

      }, (reason) => {
        `Dismissed ${this.getDismissReason(reason)}`;
      });
    } catch (error) {
      this.logger.addException(error,true);
    }
  }

  public getDismissReason(reason: any): string {
    try {
      if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
      } else {
        return `with: ${reason}`;
      }
    } catch (error) {
      this.logger.addException(error,true);
      return `with: ${reason}`;
    }
  }

  public openMenuModal(content: any) {
    try {
      this.offcanvasService.open(content, { position: 'start' }).result.then(
        (result) => {
        },
        (reason) => {
        },
      );
    } catch (error) {
      this.logger.addException(error,true);
    }
  }
}

